import React from 'react';
import s from './InputNumber.module.scss';

const InputNumber = ({
  value = 0,
  step = 1,
  customClassName = '',
  onInputChange = null,
  id,
  name,
  placeholder = '',
  disabled = false
}) => {
  return (
    <div className={s.inputWrapper}>
      <input
        type="number"
        step={step}
        value={value ?? ''}
        className={`${s.wsaInput} ${customClassName}`}
        onChange={onInputChange}
        id={id}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default InputNumber;